import { render } from "./HomeDashboardGrouping.vue?vue&type=template&id=4e87fe6b"
import script from "./HomeDashboardGrouping.vue?vue&type=script&lang=js"
export * from "./HomeDashboardGrouping.vue?vue&type=script&lang=js"

import "./HomeDashboardGrouping.vue?vue&type=style&index=0&id=4e87fe6b&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__